"use strict";
// tslint:disable:class-name no-shadowed-variable
/**
 * @file Defines the flyout helper code that is used by the flyout binding handler
 * @copyright 2016 Microsoft Corporation
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var util;
    (function (util) {
        /**
         * Gets the control element that contains the specified target element.
         * If the parent control element is inside of a reference group, it will return the reference group's element
         */
        function findParentControlElement($target) {
            var controlElement;
            if ($target) {
                var $parent = $target.addBack().closest("[data-dyn-controlname]");
                if ($parent.length) {
                    var control = $dyn.context($parent[0]);
                    controlElement = control && control.ReferenceGroup ? control.ReferenceGroup.element : $parent[0];
                }
            }
            return controlElement;
        }
        util.findParentControlElement = findParentControlElement;
    })(util = $dyn.util || ($dyn.util = {}));
    var flyout;
    (function (flyout_1) {
        /**
         * Helper class for the activeFlyout observer in the flyout binding handler
         * @param options The current flyout's options
         * @param currentFlyout The current value of activeFlyout
         * @param lastFlyout The last value of activeFlyout
         */
        // tslint:disable-next-line:class-name
        var activeFlyoutHelper = /** @class */ (function () {
            function activeFlyoutHelper(options, currentFlyout, lastFlyout) {
                this._options = options;
                this._currentFlyout = currentFlyout;
                this._lastFlyout = lastFlyout;
            }
            Object.defineProperty(activeFlyoutHelper.prototype, "repositionWrapper", {
                /**
                 * Wrapper function to call the repositionFlyout function with the correct context
                 */
                get: function () {
                    var _this = this;
                    if (!this._repositionCaller) {
                        this._repositionCaller = function () {
                            _this.repositionFlyout();
                        };
                    }
                    return this._repositionCaller;
                },
                enumerable: false,
                configurable: true
            });
            /**
             * Update the options, currentFlyout, lastFlyout props
             * @param options The current flyout's options
             * @param currentFlyout The current value of activeFlyout
             * @param lastFlyout The last value of activeFlyout
             */
            activeFlyoutHelper.prototype.updateProps = function (options, currentFlyout, lastFlyout) {
                this._options = options;
                this._currentFlyout = currentFlyout;
                this._lastFlyout = lastFlyout;
            };
            /**
             * Move the reparented flyout to it's original location
             */
            activeFlyoutHelper.prototype.reparentOnClose = function () {
                // the re-parenting of the flyout needs to be done in a timeout because events on the flyout elements which inturn
                // closes the flyout (eg: menu item click) can be bypassed when the reparenting is done immediately.
                var originalParent = this._lastFlyout[0].dynOriginalParent;
                if (this._lastFlyout[0].parentNode && originalParent && originalParent !== this._lastFlyout[0].parentNode) {
                    // make sure that the hidden attribute is not present
                    this._lastFlyout.removeClass("sysPopup-hidden");
                    // reparent
                    this._lastFlyout.detach().appendTo(originalParent);
                }
            };
            /**
             * Resize and reposition the flyout
             */
            activeFlyoutHelper.prototype.repositionFlyout = function () {
                // Before the flyout gets positioned and resized, remember the scroll position so that it can be restored
                var flyout = this._currentFlyout || this._options.flyout;
                var flyoutAnchor = $dyn.applyFunction(this._options.getAnchor) || this._options.of;
                var $flyoutAnchor;
                var anchorAsEvent = flyoutAnchor;
                if (anchorAsEvent && anchorAsEvent.target) {
                    $flyoutAnchor = $(anchorAsEvent.target);
                }
                else {
                    $flyoutAnchor = flyoutAnchor;
                }
                if ($flyoutAnchor.closest("html").length === 0) {
                    flyout.detach();
                    return;
                }
                var flyoutScrollTop = flyout ? flyout.scrollTop() : 0;
                flyout.css("max-height", "");
                flyout.css("max-width", "");
                // Resize the flyout before repositioning it
                $dyn.util.resizeFlyoutToScreen(flyout, flyoutAnchor, this._options.padding);
                $dyn.util.position(this._options, flyout);
                if (flyout) {
                    // restore the scroll position of the flyout before resizing
                    flyout.scrollTop(flyoutScrollTop);
                }
            };
            activeFlyoutHelper.prototype.getCurrentTarget = function () {
                var target = this._options.target;
                if (!target && this._options.getTarget) {
                    target = this._options.getTarget();
                }
                return target;
            };
            /**
             * Register to the relow end and window resize events to reposition the flyout
             */
            activeFlyoutHelper.prototype.setupRepositionHandlers = function () {
                if (!this._reflowHandlers) {
                    // Use the reflow end handler to handle flyout positioning when reflow completes.
                    var flyoutRelfowHandler_1; // TODO: need to remove any type after html-binding-layout is converted
                    var flyoutReflowElement = $dyn.layout.getFirstReflowElement(this._currentFlyout[0]);
                    if (flyoutReflowElement) {
                        flyoutRelfowHandler_1 = $dyn.layout.registerEndReflowHandler(this._currentFlyout[0], this.repositionWrapper);
                    }
                    var flyoutHostElement = $dyn.util.findParentControlElement(this.getCurrentTarget());
                    var parentReflowHandler_1 = $dyn.layout.registerEndReflowHandler(flyoutHostElement, this.repositionWrapper);
                    this._reflowHandlers = {
                        dispose: function () {
                            if (flyoutRelfowHandler_1) {
                                flyoutRelfowHandler_1.dispose();
                            }
                            if (parentReflowHandler_1) {
                                parentReflowHandler_1.dispose();
                            }
                        },
                    };
                }
                if (!this.resizeHandlerId) {
                    // Browser is resized or zoomed
                    this.resizeHandlerId = $dyn.shell.subscribeWindowResize(this.repositionFlyout, this);
                }
            };
            /**
             * Unbind the subscriptions created in setupRepositionHandlers
             */
            activeFlyoutHelper.prototype.unbindRepositionHandlers = function () {
                if (this._reflowHandlers) {
                    this._reflowHandlers.dispose();
                }
                if (this.resizeHandlerId) {
                    $dyn.shell.unsubscribeWindowResize(this.resizeHandlerId);
                    this.resizeHandlerId = undefined;
                }
            };
            /**
             * Whether or not the control element has a loading animation
             */
            activeFlyoutHelper.prototype.hasPendingAnimation = function () {
                var controlElement = $dyn.util.findParentControlElement(this.getCurrentTarget());
                if (controlElement) {
                    return controlElement.classList.contains("is-loading");
                }
            };
            /**
             * Repositions the flyout then sets up the handlers for dynamic repositioning
             */
            activeFlyoutHelper.prototype.setupAndRepositionFlyout = function () {
                this.repositionFlyout();
                this.setupRepositionHandlers();
            };
            /**
             * Hide the flyout and show animation until it is done loading
             */
            activeFlyoutHelper.prototype.showPopupPendingAnimation = function () {
                var _this = this;
                // Handle positioning and resizing of the flyout by hiding the flyout temporarily until it is done rendering and resizing
                var shouldRepositionAndResize = (this._options.of || this._options.getAnchor) && this._options.positionResize;
                if (!$dyn.value(this._options.optOutOfWait) && $dyn.clientBusy()) {
                    if (shouldRepositionAndResize) {
                        // Add a class to keep the flyout invisible while it is still rendering/changing size.
                        this._currentFlyout.addClass("sysPopup-hidden");
                        this.unbindRepositionHandlers();
                        var showAndRepositionFlyout_1 = function () {
                            // For flyouts that use the position and resize logic, because they will potentially change size and position while rendering
                            // keep them hidden until all pending async calls have finished, and then remove the class keeping them invisible.
                            if (_this._currentFlyout) {
                                _this.setupAndRepositionFlyout();
                                _this._currentFlyout.removeClass("sysPopup-hidden");
                            }
                        };
                        var target = this.getCurrentTarget();
                        if (target && target.length) {
                            var shouldRemoveAnimation = function () {
                                // Note: Don't eliminate the loading animation if we're still waiting for the deferred lookup to complete. This instead will be turned off
                                // by a cancel of the deferred action or the processing of the deferred popup itself when it is loaded.
                                return shouldRepositionAndResize && (!_this._currentFlyout || _this._currentFlyout.length === 0 || !_this._currentFlyout[0].wasPopupOpenedDeferredForExistingClose);
                            };
                            // Find the parent control element of the target. If the control is contained by a ReferenceGroup, use that element instead.
                            var controlElement = this._options.putAnimationOnTarget ? target[0] : $dyn.util.findParentControlElement(target);
                            $dyn.util.activateLoadingAnimation(controlElement, this, shouldRemoveAnimation, showAndRepositionFlyout_1);
                        }
                        else {
                            // No target to put the animation on, so just position the flyout when clientBusy is false
                            var subscriberId_1 = $dyn.clientBusy.valueChanged.subscribe(function () {
                                if (!$dyn.clientBusy()) {
                                    $dyn.callFunction(showAndRepositionFlyout_1, _this);
                                    $dyn.clientBusy.valueChanged.unsubscribe(subscriberId_1);
                                }
                            });
                        }
                    }
                }
            };
            return activeFlyoutHelper;
        }());
        flyout_1.activeFlyoutHelper = activeFlyoutHelper;
    })(flyout = $dyn.flyout || ($dyn.flyout = {}));
    (function (util) {
        // TODO TFS:3740413 Document
        function flyout(options, defaultVisibility) {
            var flyout = options.flyout;
            var activeFlyout = $dyn.observable();
            options.takeFocus = options.takeFocus === undefined || $dyn.shell.isPhone ? true : options.takeFocus;
            options.requestCloseCalled = false;
            options.of = options.of === undefined ? options.target : options.of;
            options.putAnimationOnTarget = options.putAnimationOnTarget === undefined ? false : options.putAnimationOnTarget;
            // The subscriber that determines whether a click should close this flyout
            var clickSubscriber = options.clickSubscriber || $dyn.util.flyout.defaultFlyoutClickSubscriber;
            var escapeSubscriber = options.escapeSubscriber || $dyn.util.flyout.defaultFlyoutEscapeSubscriber;
            // Keeps track of whether the flyout has been added to the global flyout stack, which happens
            // when the flyout is opened
            var flyoutIsRegistered = false;
            function callRequestCloseAsync(callback) {
                var deferred = $.Deferred();
                options.requestCloseCalled = true;
                var record;
                if (callback) {
                    if (callback.type === "resetShellOnNavigation") {
                        record = false;
                    }
                }
                $dyn.getFunction(options.requestClose)(closeSucceeded, record);
                return deferred.promise();
                function closeSucceeded() {
                    $dyn.getFunction(callback)();
                    deferred.resolve();
                }
            }
            function callRequestCloseSync(callback) {
                options.requestCloseCalled = true;
                $dyn.getFunction(options.requestClose)();
                $dyn.getFunction(callback)();
                // Return a resolved Deferred so that the "then" in the flyoutManager executes immediately.
                return $.Deferred().resolve();
            }
            // The object registered and unregistered with the flyoutManager
            var flyoutRegistryInformation = {
                clickSubscriber: clickSubscriber,
                escapeSubscriber: escapeSubscriber,
                flyout: activeFlyout,
                getTarget: options.getTarget,
                highlyResponsive: options.highlyResponsive,
                requestClose: options.highlyResponsive ? callRequestCloseSync : callRequestCloseAsync,
                showFlyout: options.show,
                target: options.target,
            };
            if (flyout && flyout.length === 1) {
                $dyn.util.setVisibility(flyout[0], false, defaultVisibility);
            }
            options.requestPopup = options.requestPopup
                ? options.requestPopup
                : function setFlyout(flyoutObservable) {
                    flyoutObservable(flyout);
                    return flyout;
                };
            options.requestClose = function closeFlyout(closeCallback) {
                activeFlyout(null);
                if (options.show()) {
                    options.show(false);
                }
                if (closeCallback && typeof closeCallback === "function") {
                    closeCallback();
                }
            };
            var lastFlyout;
            var helper;
            options.activeFlyoutSubscriber = $dyn.observe(activeFlyout, function activeFlyoutChanged(currentFlyout) {
                if (currentFlyout) {
                    lastFlyout = currentFlyout;
                }
                if (!helper) {
                    helper = new $dyn.flyout.activeFlyoutHelper(options, currentFlyout, lastFlyout);
                }
                else {
                    helper.updateProps(options, currentFlyout, lastFlyout);
                }
                function entranceAnimationEnd() {
                    jQuery(this)
                        .removeClass($dyn.value(options.entranceAnimation))
                        .css("animation-play-state", "");
                    this.removeEventListener("animationend", entranceAnimationEnd);
                    this.removeEventListener("webkitAnimationEnd", entranceAnimationEnd);
                }
                function exitAnimationEnd() {
                    var el = jQuery(this);
                    // If the user has clicked real fast, we could be closing while opening. Let the opening win
                    if (el.hasClass($dyn.value(options.entranceAnimation)) && options.show()) {
                        return;
                    }
                    el.removeClass($dyn.value(options.exitAnimation)).css("animation-play-state", "");
                    this.removeEventListener("animationend", exitAnimationEnd);
                    this.removeEventListener("webkitAnimationEnd", exitAnimationEnd);
                    options.show(false);
                    $dyn.util.setVisibility(lastFlyout[0], false, defaultVisibility);
                    // the re-parenting of the flyout needs to be done in a timeout because events on the flyout elements which inturn
                    // closes the flyout (eg: menu item click) can be bypassed when the reparenting is done immediately.
                    helper.reparentOnClose();
                }
                var showFlyout = options.show();
                var target = options.target;
                if (!target && options.getTarget && options.getTarget().length > 0) {
                    target = options.getTarget();
                }
                if (target && !$dyn.value(options.skipAria) && showFlyout !== undefined) {
                    target.attr("aria-expanded", showFlyout.toString());
                }
                var flyoutContext;
                if (showFlyout && currentFlyout && currentFlyout[0]) {
                    // Opening the flyout
                    flyoutContext = $dyn.context(currentFlyout[0]);
                    // Register the flyout and add it the the flyout stack
                    if (!flyoutIsRegistered) {
                        if (flyoutContext) {
                            var handlerId = "resetShellOnNavigation." + flyoutContext.Id;
                            $(document.body).on(handlerId, flyoutRegistryInformation.requestClose);
                            flyoutRegistryInformation.handle = handlerId;
                        }
                        flyoutRegistryInformation.options = options;
                        // track the scroll containers
                        // if there is no target or options.scrollTarget set and the options.of is a jquery object use that as the starting point to track scroll containers
                        var scrollTarget = options.scrollTarget || target || (options.of && options.of.jquery ? options.of : undefined);
                        if (!scrollTarget && options.getAnchor && options.getAnchor().length > 0) {
                            scrollTarget = $dyn.applyFunction(options.getAnchor);
                        }
                        if (scrollTarget) {
                            options.scrollParents = [];
                            var scrollParent = scrollTarget.scrollParent();
                            while (scrollParent.length > 0 && scrollParent[0] !== document) {
                                options.scrollParents.push(scrollParent);
                                scrollParent.off("scroll.flyout");
                                scrollParent.on("scroll.flyout", $dyn.flyout.flyoutManager.repositionAllFlyouts);
                                scrollParent = scrollParent.scrollParent();
                            }
                        }
                        // Set the current handler as a tabbing container
                        flyoutRegistryInformation.tabbingHandlerDispose = $dyn.util.tabbingContainer(currentFlyout[0]);
                        $dyn.flyout.flyoutManager.addFlyout(flyoutRegistryInformation);
                        flyoutIsRegistered = true;
                        $(document).trigger("flyoutRegistered");
                    }
                    helper.showPopupPendingAnimation();
                    // re-parent the flyout to the appropriate element. the close of the flyout puts the flyout under its original parent
                    // this is done to avoid flyouts clipping off when the original flyout parent has overflow set to hidden.
                    // reparenting of the flyout can cause databinding issues if the contents of the flyout are not bound before the reparenting happens.
                    if ($dyn.value(options.moveTo) !== false && currentFlyout[0].parentNode !== document.body) {
                        var originalParent = currentFlyout[0].parentNode;
                        var newParent = currentFlyout.parents($dyn.value(options.moveTo)).first();
                        if (newParent.length === 0) {
                            // If a new parent isn't found default to the body.
                            newParent = $("body");
                        }
                        currentFlyout.detach().appendTo(newParent);
                        currentFlyout[0].dynOriginalParent = originalParent;
                    }
                    // Set the visibility of the flyout. Do this after re-parenting so the flyout does not take up space in the original position and cause the target to potentially move.
                    if (flyoutContext && typeof flyoutContext.RequestOpen === "function") {
                        flyoutContext.RequestOpen(defaultVisibility);
                    }
                    else {
                        if ($dyn.value(options.entranceAnimation)) {
                            // The animation has to start out paused and setVisibility will start it.
                            currentFlyout
                                .removeClass($dyn.value(options.exitAnimation))
                                .addClass($dyn.value(options.entranceAnimation))
                                .css("animation-play-state", "paused");
                            currentFlyout[0].addEventListener("animationend", entranceAnimationEnd);
                            currentFlyout[0].addEventListener("webkitAnimationEnd", entranceAnimationEnd);
                        }
                        $dyn.util.setVisibility(currentFlyout[0], true, defaultVisibility);
                        if ($dyn.value(options.entranceAnimation)) {
                            currentFlyout.css("animation-play-state", "running");
                        }
                    }
                    // calcuate if z-index needs to be tweaked for popups on lightboxes
                    var contextCurrentFlyout = $dyn.context(currentFlyout[0]);
                    if (contextCurrentFlyout && contextCurrentFlyout.Root && contextCurrentFlyout.Root.TypeName === "LightBox") {
                        currentFlyout.addClass("lightbox-flyout");
                    }
                    // Set the flyout IsActive to true to trigger the initial layout
                    if (flyoutContext && flyoutContext.IsActive) {
                        flyoutContext.IsActive(true);
                    }
                    else if (!currentFlyout[0].dynHasArranged) {
                        // If the flyout does not have IsActive, then arrange it once for the first time when initially opened.
                        // The next time it gets opened, it will get queued for an arrange in $dyn.util.setVisibility.
                        $dyn.layout.arrange(currentFlyout[0], true);
                    }
                    if ((options.of || options.getAnchor) && options.at !== "manual") {
                        // set the min-width of the flyout
                        if (options.of && options.of.outerWidth) {
                            // we check this since options.of can be a jquery event too
                            var ofWidth = options.of.outerWidth();
                            var flyoutMinWidth = ofWidth - (currentFlyout.outerWidth() - currentFlyout.innerWidth());
                            currentFlyout.css("min-width", flyoutMinWidth + "px");
                        }
                        if (options.positionResize) {
                            // if pending animation do nothing because we have a reposition call at the end of animation
                            if (!helper.hasPendingAnimation()) {
                                helper.setupAndRepositionFlyout();
                            }
                            if (options.repositionFlyout) {
                                // Define the repositionFlyout option as a function to call the resize/reposition code.
                                $dyn.setValue(options, "repositionFlyout", function callRepositionFlyout() {
                                    $dyn.async(helper.repositionFlyout, undefined, "Reposition flyout", helper);
                                });
                            }
                        }
                        else {
                            $dyn.util.position(options, currentFlyout);
                        }
                    }
                    if ($dyn.value(options.takeFocus) && !$dyn.util.isForm(currentFlyout[0])) {
                        $dyn.util.flyout.focusFirstControlInFlyout(currentFlyout[0]);
                    }
                }
                else {
                    // Closing the flyout or initializing closed flyout
                    if (flyoutIsRegistered) {
                        $(document).trigger("flyoutRemoved");
                        $dyn.flyout.flyoutManager.removeFlyout(flyoutRegistryInformation);
                        flyoutIsRegistered = false;
                    }
                    // Remove the repositioning handlers
                    helper.unbindRepositionHandlers();
                    if (target) {
                        if (!$dyn.value(options.skipAria)) {
                            target.attr("aria-expanded", "false");
                        }
                        if (options.requestPopup && target.length) {
                            target[0].dynFlyout = undefined;
                        }
                    }
                    if (lastFlyout) {
                        if (($dyn.value(options.takeFocus) || $.contains(lastFlyout[0], document.activeElement)) && target && !$dyn.shell.isPhone) {
                            var targetContext = target.length && $dyn.ui.getLiveControl(target[0]);
                            if (targetContext && targetContext.Root && targetContext.Root.setControlFocus) {
                                targetContext.Root.setControlFocus(targetContext.Name);
                            }
                        }
                        if ($dyn.value(options.exitAnimation)) {
                            lastFlyout.addClass($dyn.value(options.exitAnimation));
                            lastFlyout[0].addEventListener("animationend", exitAnimationEnd);
                            lastFlyout[0].addEventListener("webkitAnimationEnd", exitAnimationEnd);
                        }
                        else {
                            $dyn.util.setVisibility(lastFlyout[0], false, defaultVisibility);
                            // the re-parenting of the flyout needs to be done in a timeout because events on the flyout elements which inturn
                            // closes the flyout (eg: menu item click) can be bypassed when the reparenting is done immediately.
                            window.setTimeout(function asyncReparent() {
                                helper.reparentOnClose();
                            });
                        }
                    }
                    if (flyoutContext && flyoutContext.IsActive) {
                        flyoutContext.IsActive(false);
                    }
                }
            });
            options.showSubscriber = $dyn.observe(options.show, function flyout_showChanged(showFlyout) {
                var e_1, _a;
                flyout = options.flyout;
                if (showFlyout) {
                    options.requestCloseCalled = false;
                    if (options.requestPopup) {
                        flyout = options.flyout = options.requestPopup(activeFlyout, options);
                        var target = options.target;
                        if (!target && options.getTarget) {
                            target = options.getTarget();
                        }
                        if (target && target.length) {
                            target[0].dynFlyout = flyout;
                        }
                        // Special handling for when requestPopup is used to obtain the flyout object.
                        // A calling object may implement Close, which will be used instead of
                        // the default
                        var flyoutContext = void 0;
                        if (flyout) {
                            flyoutContext = $dyn.context(flyout[0]);
                            if (flyout[0].RequestPopupClose || (flyoutContext && flyoutContext.Close)) {
                                options.requestClose = flyout[0].RequestPopupClose || $dyn.getFunction(flyoutContext.Close);
                            }
                        }
                        if (flyoutContext) {
                            flyoutContext.TakeFocus = $dyn.value(options.takeFocus);
                            var targetContext = target && target.length ? $dyn.ui.getLiveControl(target[0]) : undefined;
                            if (targetContext && options.focusTarget && typeof (options.focusTarget) === "function") {
                                flyoutContext.FindFocusTarget = options.focusTarget.bind(targetContext);
                            }
                            else {
                                flyoutContext.FindFocusTarget = options.focusTarget;
                            }
                        }
                    }
                }
                else {
                    // RequestClose was being called in several places and resulted in the interaction being
                    // created more than once. In this case as a result of the first RequestClose call
                    // $dyn.controls.Popup _close was called and calls popup[0].dynClose dynClose sets the
                    // ShowFlyout and triggers this observer and would call RequestClose again
                    if (!options.requestCloseCalled) {
                        callRequestCloseAsync();
                    }
                    // remove the scroll parents handlers and clear the list
                    if (options.scrollParents) {
                        try {
                            for (var _b = __values(options.scrollParents), _c = _b.next(); !_c.done; _c = _b.next()) {
                                var scrollParent = _c.value;
                                scrollParent.off("scroll.flyout");
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        options.scrollParents = [];
                    }
                }
            });
            if ($dyn.isObservable(options.skipAria)) {
                // Put on options object so it can be disposed in the dispose method of the binding handler
                options.ariaSubscriber = $dyn.observe(options.skipAria, function (newValue) {
                    var target = options.target;
                    if (!target && options.getTarget) {
                        target = options.getTarget();
                    }
                    if (target && target.length) {
                        if ($dyn.value(newValue)) {
                            options.target.removeAttr("aria-expanded");
                        }
                        else {
                            var show = $dyn.value(options.show);
                            if (show !== undefined) {
                                options.target.attr("aria-expanded", show.toString());
                            }
                        }
                    }
                });
            }
        }
        util.flyout = flyout;
        (function (flyout_2) {
            flyout_2.forceFlyoutSelection = false;
            /**
             * Handles click events when flyouts are open and calls each
             * flyout's clickSubscriber
             * @param evt The click event that occurred.
             */
            function clickHandler(evt) {
                if ($dyn.util.flyout.wasLightboxClicked(evt.target)) {
                    // tracking when the code is causing events to be eaten this effects when a flyout is close by clicking a button for example.
                    $dyn.log.blockUserInteraction && $dyn.log.blockUserInteraction("BlockUserInteraction: flyout.clickHandler Skipping the mouse event due to the presence of the blocking div");
                    return;
                }
                $dyn.flyout.flyoutManager.removeAllFlyoutsAsync(evt);
            }
            flyout_2.clickHandler = clickHandler;
            /**
             * @param clickTarget The HTML element that was clicked
             * @returns True if the given element is a lightbox, false otherwise.
             */
            function wasLightboxClicked(clickTarget) {
                // Do not execute click handler logic if the click was on a lightbox or the
                // blocking div that the lightbox shows.
                if ((clickTarget.classList !== undefined && clickTarget.classList.contains("applicationShell-blockingMessage")) ||
                    $(clickTarget).parents(".lightbox-container").length) {
                    return true;
                }
                return false;
            }
            flyout_2.wasLightboxClicked = wasLightboxClicked;
            /**
             * Handles keydown events when flyouts are open.
             * @remarks Closes the top flyout if esc is pressed.
             * @param evt The keydown event that occurred.
             */
            function keyDownHandler(evt) {
                var topFlyout = null;
                if ($dyn.flyout.flyoutManager.areAnyFlyoutsOpen()) {
                    topFlyout = $dyn.flyout.flyoutManager.getTopFlyout();
                }
                if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.esc })) {
                    var isOnOpenDatePickerWidget = ($dyn.context(evt.target) && $dyn.value($dyn.context(evt.target).pickerOpen))
                        || $(evt.target).parents(".ui-datepicker").length > 0;
                    if (topFlyout && topFlyout.escapeSubscriber && !isOnOpenDatePickerWidget) {
                        if ($dyn.util.flyout.forceFlyoutSelection) {
                            // do not close the flyout and stop propagation, so we can force selection on the flyout
                            $dyn.log.stopPropagation && $dyn.log.stopPropagation("Flyout: escape key / forceFlyoutSelection=true / stopPropagation");
                            evt.stopPropagation();
                            evt.preventDefault(); // prevent default to prevent behavior such as lookups reverting their value when canceled in IE.
                        }
                        else {
                            // The layout flag should be set before any closing the flyout, if not already set, so that we can batch the elements that need to be laid out, and
                            // determine where to reflow the page from.
                            // If layout flag is not set, the flyout element will get arranged immediately.
                            var setLayout = false;
                            if (!$dyn.value($dyn.ui.layout)) {
                                $dyn.ui.layout(true);
                                setLayout = true;
                            }
                            $dyn.getFunction(topFlyout.escapeSubscriber)();
                            $dyn.log.stopPropagation && $dyn.log.stopPropagation("Flyout: escape key / stopPropagation");
                            evt.stopPropagation();
                            evt.preventDefault(); // prevent default to prevent behavior such as lookups reverting their value when canceled in IE.
                            if (setLayout) {
                                $dyn.ui.layout(false);
                            }
                        }
                    }
                }
            }
            flyout_2.keyDownHandler = keyDownHandler;
            /**
             * Compare the focus region of the target with the flyout region.
             * @remarks Flyouts are not dismissed if the body click originated from a
             * different focus region than where the topFlyout belongs to.
             * @param target
             */
            function isClosableFocusRegion(target) {
                var topFlyout = null;
                if ($dyn.flyout.flyoutManager.areAnyFlyoutsOpen()) {
                    topFlyout = $dyn.flyout.flyoutManager.getTopFlyout();
                }
                if (topFlyout) {
                    var clickFocusRegion = $(target).closest(".binding-focusRegion")[0];
                    var flyoutFocusRegion = $dyn.flyout.flyoutManager.getFlyoutFocusRegion(topFlyout);
                    if (clickFocusRegion != null && flyoutFocusRegion != null) {
                        if (flyoutFocusRegion !== clickFocusRegion || $dyn.util.flyout.forceFlyoutSelection) {
                            return false;
                        }
                    }
                }
                return true;
            }
            flyout_2.isClosableFocusRegion = isClosableFocusRegion;
            /**
             * This is the handler called by default for a flyout when a
             * click event is detected. Sets showFlyout(false) if the target element
             * is a child of the activeFlyout.
             * @returns True if the flyout was closed by the click.
             */
            function defaultFlyoutClickSubscriber(options) {
                var closeFlyout = false;
                var context;
                if (options.flyoutElement && options.flyoutElement[0]) {
                    context = $dyn.context(options.flyoutElement[0]);
                }
                if (!options.flyoutElement) {
                    closeFlyout = true;
                }
                else if (context && $dyn.value(context.IsFormReady) === false) {
                    // if they try to close the flyout before its ready we can't close it yet
                    closeFlyout = false;
                }
                else if (options.clickInsideTopFlyout) {
                    closeFlyout = false;
                }
                else if (options.isClickInsideThisFlyout) {
                    closeFlyout = false;
                }
                else if (options.flyoutElement.length) {
                    closeFlyout = true;
                }
                return closeFlyout;
            }
            flyout_2.defaultFlyoutClickSubscriber = defaultFlyoutClickSubscriber;
            /**
             * Generates a flyout click subscriber that closes the flyout if
             * the click occurred outside the flyout or the click occurred on an
             * element in the flyout that matches the selector
             * @param selector A CSS selector. If the click occurred on an
             * element that matches this selector, the flyout is closed.
             */
            function getFlyoutWithActionsClickSubscriber(selector) {
                /**
                 * This handler sets showFlyout(false) if the target element
                 * is a child of the activeFlyout or if the click occurred on an
                 * element in the flyout that matches a selector.
                 * @param options
                 * @returns True if the flyout was closed by the click
                 */
                return function flyoutWithActionsClickSubscriber(options) {
                    if (options.flyoutElement && options.flyoutElement.length) {
                        var clickInFlyout = options.isClickInsideThisFlyout;
                        // If the click was in the flyout and was a right click do not close the flyout let the context menu display
                        if (options.isRightClick && clickInFlyout) {
                            return false;
                        }
                        // if the click wasn't on the flyout, inside the flyout, or on an element inside the flyout, or it is a date picker
                        // or if the click was on an element that matches the selector
                        if (!clickInFlyout ||
                            $(options.clickTarget).is(selector) ||
                            $(options.clickTarget)
                                .parentsUntil(options.flyoutElement[0])
                                .is(selector)) {
                            return true;
                        }
                    }
                    return false;
                };
            }
            flyout_2.getFlyoutWithActionsClickSubscriber = getFlyoutWithActionsClickSubscriber;
            /**
             * Check to see if the click is in the flyout.
             * @param target The element that received the click event.
             * @param activeFlyout The flyout element.
             * @param x The x coordinate
             * @param y The y coordinate
             * @returns True if the click is with in the flyout
             */
            function IsClickInFlyout(target, activeFlyout, x, y) {
                if (activeFlyout === undefined || activeFlyout.length === 0) {
                    return false;
                }
                // If react grid flight is on and target is within control lib flyout, return true
                if ($dyn.util.isFlightEnabled($dyn.reactGrid.featureName) && $(target).closest(".dyn-flyout").length > 0) {
                    return true;
                }
                return $(target).is(activeFlyout[0]) || $dyn.util.flyout.isCoordinateInside(x, y, activeFlyout) || $.contains(activeFlyout[0], target);
            }
            flyout_2.IsClickInFlyout = IsClickInFlyout;
            /**
             * Handles an escape for flyouts. Sets showFlyout to false
             */
            function defaultFlyoutEscapeSubscriber() {
                $dyn.flyout.flyoutManager.removeTopFlyoutAsync();
            }
            flyout_2.defaultFlyoutEscapeSubscriber = defaultFlyoutEscapeSubscriber;
            /**
             * Checks whether the x,y corrdinate is inside the element
             * @param x The x coordinate
             * @param y The y coordinate
             * @param element The element that the coordinate may be inside
             * @returns True if the x,y coordinate is inside the element
             */
            function isCoordinateInside(x, y, element) {
                var elementCorners = element.offset();
                if (elementCorners) {
                    elementCorners.right = elementCorners.left + element.outerWidth();
                    elementCorners.bottom = elementCorners.top + element.outerHeight();
                    return x >= elementCorners.left && x <= elementCorners.right && y >= elementCorners.top && y <= elementCorners.bottom;
                }
                else {
                    return false;
                }
            }
            flyout_2.isCoordinateInside = isCoordinateInside;
            /**
             * Finds the first focusable control within the flyout and focuses it.
             * @param flyoutElement The flyout to give focus to.
             */
            function focusFirstControlInFlyout(flyoutElement) {
                // We're probably waiting for child controls to be created,
                // so do this after all actions have completed
                $dyn.observe($dyn.async.pending, function (pending) {
                    if (!pending) {
                        var firstControlElement = $dyn.util.findFirstFocusableControl(flyoutElement);
                        var firstControl = $dyn.context(firstControlElement);
                        if (firstControl && firstControl.Root && firstControl.Root.setControlFocus) {
                            firstControl.Root.setControlFocus(firstControl.Name);
                        }
                        else {
                            var form = $dyn.context($dyn.shell.getActiveForm());
                            var flyout_3 = $dyn.context(flyoutElement);
                            var isNavBar = flyout_3 ? flyout_3.Id === "NavBar" : false;
                            var isUserButton = flyout_3 ? flyout_3.Name === "UserButton" : false;
                            // client side flyouts will not be the active form (like message center)
                            if (form && !isNavBar && !isUserButton) {
                                form.setControlFocus(firstControlElement);
                            }
                        }
                        return false;
                    }
                    return true;
                });
            }
            flyout_2.focusFirstControlInFlyout = focusFirstControlInFlyout;
        })(flyout = util.flyout || (util.flyout = {}));
        /**
         * Closes a mobile flyout
         */
        function closePhoneFlyout() {
            if ($dyn.util.phoneOpenedFlyout && $dyn.util.phoneOpenedFlyout[0] && $dyn.util.phoneOpenedFlyout[0].RequestPopupClose) {
                $dyn.util.phoneOpenedFlyout[0].RequestPopupClose();
            }
            $dyn.util.phoneOpenedFlyout = undefined;
        }
        util.closePhoneFlyout = closePhoneFlyout;
        /**
         * Tells if flyout is a phone lookup
         * @param $flyout The flyout to resize.
         * @param flyoutLocation The anchor for the flyout.
         * @returns True if it is a mobile lookup flyout
         */
        function isFlyoutAPhoneLookup($flyout, flyoutLocation) {
            var $rootContent;
            var $lookupButton;
            var isPhoneLookup = false;
            if ($flyout && $flyout.length > 0) {
                $rootContent = $flyout.find(".rootContent");
                if (flyoutLocation && $(flyoutLocation).length > 0) {
                    $lookupButton = $(flyoutLocation).find(".lookupButton");
                    if ($lookupButton.length === 0) {
                        $lookupButton = $($(flyoutLocation)[0].nextSibling).find(".lookupButton");
                    }
                }
                if ($dyn.shell.isPhone && flyoutLocation && $lookupButton && $lookupButton.length > 0 && $rootContent && $rootContent.length > 0) {
                    isPhoneLookup = true;
                }
            }
            return isPhoneLookup;
        }
        util.isFlyoutAPhoneLookup = isFlyoutAPhoneLookup;
        /**
         * Resize the given flyout by setting a max-width, and max-height so that it is never allowed to go offscreen.
         * @param $flyout The flyout to resize.
         * @param flyoutLocation The anchor for the flyout.
         * @param paddingOptions the amount of padding that the flyout has from the edge of the screen.
         */
        function resizeFlyoutToScreen($flyout, flyoutLocation, paddingOptions) {
            if ($flyout && $flyout.length) {
                if ($dyn.util.isFlyoutAPhoneLookup($flyout, flyoutLocation)) {
                    var $rootContent = $flyout.find(".rootContent");
                    $flyout.addClass("phoneSysPopup");
                    $flyout.addClass("layout-vertical");
                    $flyout.addClass("layout-container");
                    $rootContent.addClass("fill-height");
                    var $closeButton = $flyout.find(".phonePopupCloseButton");
                    $dyn.util.phoneOpenedFlyout = $flyout;
                    if ($closeButton.length === 0) {
                        $rootContent.prepend('<button type="button" onclick="$dyn.util.closePhoneFlyout();" class="phonePopupCloseButton button dynamicsButton">' + $dyn.label("MessageBox_Close") + "</button>");
                    }
                }
                else {
                    var paddingTop = 0;
                    var paddingBottom = 0;
                    var paddingLeft = 0;
                    var paddingRight = 0;
                    if (paddingOptions) {
                        paddingTop = paddingOptions.top ? paddingOptions.top : paddingTop;
                        paddingBottom = paddingOptions.bottom ? paddingOptions.bottom : paddingBottom;
                        paddingLeft = paddingOptions.left ? paddingOptions.left : paddingLeft;
                        paddingRight = paddingOptions.right ? paddingOptions.right : paddingRight;
                    }
                    var windowHeight_1 = $(window).height();
                    var windowWidth_1 = $(window).width();
                    var flyoutLocationOffset = void 0;
                    var flyoutLocationWidth = 0;
                    if (flyoutLocation.pageY === undefined) {
                        var $flyoutLocation = $(flyoutLocation);
                        flyoutLocationOffset = $flyoutLocation.offset();
                        flyoutLocationWidth = $flyoutLocation.outerWidth();
                    }
                    else {
                        flyoutLocationOffset = {
                            left: flyoutLocation.pageX,
                            top: flyoutLocation.pageY,
                        };
                    }
                    var flyoutLocationHeight_1 = 0;
                    if (flyoutLocation.height) {
                        if (typeof flyoutLocation.height === "function") {
                            flyoutLocationHeight_1 = flyoutLocation.height();
                        }
                        else {
                            flyoutLocationHeight_1 = flyoutLocation.height;
                        }
                    }
                    flyoutLocationWidth = 0;
                    if (flyoutLocation.width) {
                        if (typeof flyoutLocation.width === "function") {
                            flyoutLocationWidth = flyoutLocation.width();
                        }
                        else {
                            flyoutLocationWidth = flyoutLocation.width;
                        }
                    }
                    // space from bottom is space between bottom part of control and window edge
                    flyoutLocationOffset.bottom = windowHeight_1 - (flyoutLocationOffset.top + flyoutLocationHeight_1);
                    // space from right is space between right part of control and window edge
                    flyoutLocationOffset.right = windowWidth_1 - (flyoutLocationOffset.left + flyoutLocationWidth);
                    var flyoutOffset = $flyout.offset();
                    var flyoutHeight_1 = $flyout.height();
                    var flyoutWidth_1 = $flyout.width();
                    var flyoutOuterWidth = $flyout.outerWidth();
                    var flyoutOuterHeight = $flyout.outerHeight();
                    var flyoutWidthPadding = flyoutOuterWidth - flyoutWidth_1;
                    var flyoutHeightPadding = flyoutOuterHeight - flyoutHeight_1;
                    // If the flyout is positioned below the target, set the max-height to be the amount of space between the target and the edge of the window
                    // minus the padding amount that was passed in for bottom
                    if (flyoutOffset && flyoutLocationOffset) {
                        var maxHeight = void 0;
                        var flyOutOpeningDownwards = flyoutLocationOffset.top <= flyoutLocationOffset.bottom;
                        var getMaxHeight = function (flyoutEdgeLocation) {
                            var calculatedHeight = flyoutHeight_1; // use height so it doesn't include padding/borders
                            // Flyout opens below or above the control
                            // so we need to add the height of the control because it is that position from where flyout starts
                            var flyoutEdgePosition = flyoutEdgeLocation + flyoutLocationHeight_1 + flyoutHeight_1;
                            if (flyoutEdgePosition > windowHeight_1) {
                                calculatedHeight = flyoutHeight_1 - (flyoutEdgePosition - windowHeight_1);
                            }
                            else {
                                // -20 is to make sure the flyout stops before bottom so we get all the shadow visuals needed
                                calculatedHeight = windowHeight_1 - (flyoutEdgeLocation + flyoutLocationHeight_1) - 20;
                            }
                            return calculatedHeight;
                        };
                        // Here we are checking if flyout rendering is going outside window based on the location of flyout hosting element
                        if (flyOutOpeningDownwards) {
                            maxHeight = getMaxHeight(flyoutLocationOffset.top);
                        }
                        else {
                            maxHeight = getMaxHeight(flyoutLocationOffset.bottom);
                        }
                        if (flyOutOpeningDownwards) {
                            if (flyoutLocationOffset.top + flyoutLocationHeight_1 + flyoutHeight_1 > windowHeight_1) {
                                maxHeight = maxHeight - paddingBottom - flyoutHeightPadding;
                            }
                        }
                        else {
                            // If the flyout is positioned above the target, set  the max height to be the current height of the flyout. If allowed to expand from there,
                            // it could potentially go offscreen, and be incorrectly positioned, because it will expand downwards.
                            // This max-height will be removed the next time position is called, so that the flyout can take up as much space allowed after resizing.
                            if (flyoutOffset.top < paddingTop) {
                                // If the flyout was going offscreen, set the top coordinate to the padding amount so that the flyout remains in the same location.
                                // The maximum height is just the top of the target location minus the padding.
                                $flyout.css("top", paddingTop + "px");
                                maxHeight = maxHeight - paddingTop - flyoutHeightPadding;
                            }
                        }
                        $flyout.css("max-height", (maxHeight > 0 ? maxHeight : 0) + "px");
                        var maxWidth = void 0;
                        var flyOutOpeningRight = flyoutLocationOffset.left <= flyoutLocationOffset.right;
                        var getMaxWidth = function (flyoutEdgeLocation) {
                            var calculatedWidth = flyoutWidth_1; // use width so it doesn't include padding/borders
                            // Flyout starts from the edge of the control (flyoutLocation),
                            // so width of the control is covered in flyout width and we do not need to add the control width
                            var flyoutEdgePosition = flyoutEdgeLocation + flyoutWidth_1;
                            if (flyoutEdgePosition > windowWidth_1) {
                                calculatedWidth = flyoutWidth_1 - (flyoutEdgePosition - windowWidth_1);
                            }
                            else {
                                calculatedWidth = windowWidth_1 - flyoutEdgeLocation;
                            }
                            return calculatedWidth;
                        };
                        // Here we are checking if flyout rendering is going outside window based on the location of flyout hosting element
                        if (flyOutOpeningRight) {
                            maxWidth = getMaxWidth(flyoutLocationOffset.left);
                        }
                        else {
                            maxWidth = getMaxWidth(flyoutLocationOffset.right);
                        }
                        // If the flyout is positioned to the right of the target, set the max-width to be the amount of space between the left side of the target and the edge of the window
                        // minus the padding amount that was passed in for right
                        if (flyOutOpeningRight) {
                            if ($dyn.util.isRTLMode()) {
                                $flyout.css("left", windowWidth_1 - flyoutOffset.left + "px");
                                flyoutOffset.left = windowWidth_1 - flyoutOffset.left;
                            }
                            if (flyoutLocationOffset.left + flyoutWidth_1 > windowWidth_1) {
                                maxWidth = maxWidth - paddingRight - flyoutWidthPadding;
                            }
                        }
                        else {
                            // If the flyout is positioned to the left of the target, set  the max-width to be the current width of the flyout. If allowed to expand from there,
                            // it could potentially go offscreen, and be incorrectly positioned, because it will expand to the right.
                            // This max-height will be removed the next time position is called, so that the flyout can take up as much space as it is allowed.
                            if (flyoutOffset.left < paddingLeft) {
                                // Readjust the left if the flyout was going offscreen so that the flyout remains in the same position.
                                $flyout.css("left", paddingLeft + "px");
                                maxWidth = maxWidth - paddingLeft - flyoutWidthPadding;
                            }
                        }
                        $flyout.css("max-width", (maxWidth > 0 ? maxWidth : 0) + "px");
                    }
                }
            }
        }
        util.resizeFlyoutToScreen = resizeFlyoutToScreen;
    })(util = $dyn.util || ($dyn.util = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=flyoutHelper.js.map
